import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FastService {

  private baseUrl = `${environment.API_URL_TV_BASE}partner/v1`;
  private orgId = 47;
  private showferOrgId: number | null = null;

  constructor(private http: HttpClient) {}

  setOrganizationId(orgId: number): void {
    this.orgId = orgId;
  }

  setShowferOrgId(showferOrgId: number): void {
    this.showferOrgId = showferOrgId;
  }

  getGroupChannels(): Observable<any> {
    let url = `${this.baseUrl}/schedule/group-channels?organization_id=${this.orgId}`;
    if (this.showferOrgId) {
      url += `&showfer_id=${this.showferOrgId}`;
    }
    return this.http.get(url);
  }
}